import React from 'react';
import { Input, message, Button } from 'antd';
import Title from '../../../Components/Common/pageTitle';
import { TableWrapper, TableContainer, Label, ValueBox } from './info.styled';

import axios from '../../../Lib/axios';
import TextArea from 'antd/lib/input/TextArea';
import { getCardInfo } from '../../../Lib/Api/app';
import { InfoBlock } from '../../../Components/Common/block';

export default class CardInfo extends React.PureComponent {
    state = {
        data: {},
    };

    componentDidMount = () => {
        const { state } = this.props.history.location;
        if (!state || !state.id) return this.props.history.goBack();

        this.fetchInfo(state.id);
    };

    fetchInfo = async id => {
        const { data } = await axios.get('/v1/auth/card/list/info', {
            params: {
                cardId: id,
            },
        });

        if (!data || data === 'check parameters') {
            return this.props.history.goBack();
        }

        if (data === 'invalid card') {
            return message.warning('잘못된 게시물 정보입니다.');
        }

        this.setState({ ...data });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    render() {
        // console.log(this.state);
        return (
            <>
                <Title title='고객 결제카드 정보' />
                <TableWrapper>
                    <TableContainer>
                        {this.state && (
                            <>
                                <div className='table'>
                                    <InfoBlock label='고객이름' value={this.state.userName} />
                                    <InfoBlock label='카드명' value={this.state.cardName} />
                                    <InfoBlock label='카드번호' value={this.state.cardNum} />
                                    <InfoBlock label='유효기간 (년/월)' value={this.state.year + '\n' + '/' + '\n' + this.state.month} />
                                </div>
                            </>
                        )}
                    </TableContainer>
                </TableWrapper>
            </>
        );
    }
}
